import { DefaultValue, atom, selector } from "recoil";
import { IsAlbum, IsDocuments } from "../type/album";

export const documents = atom<IsDocuments>({
  key: "documents",
  default: {
    currentDocs: null,
    userDocs: null,
    searchValue: "",
  },
});

export const currentDocuments = selector({
  key: "currentDocuments",
  get: ({ get }) => {
    const result = get(documents);
    return result.currentDocs;
  },
  set: ({ set, get }, newValue) => {
    const oldDocs = get(documents);

    set(
      documents,
      newValue instanceof DefaultValue
        ? oldDocs
        : { ...oldDocs, currentDocs: newValue }
    );
  },
});

export const userDocuments = selector({
  key: "userDocuments",
  get: ({ get }) => {
    const result = get(documents);
    return result.userDocs;
  },
  set: ({ set, get }, newValue) => {
    const oldDocs = get(documents);

    set(
      documents,
      newValue instanceof DefaultValue
        ? oldDocs
        : { ...oldDocs, userDocs: newValue }
    );
  },
});

export const searchInDocs = selector({
  key: "searchInDocs",
  get: ({ get }) => {
    const result = get(documents);
    return result.searchValue;
  },
  set: ({ set, get }, newValue) => {
    const oldDocs = get(documents);

    set(
      documents,
      newValue instanceof DefaultValue
        ? oldDocs
        : { ...oldDocs, searchValue: newValue }
    );
  },
});
